import { BaseResponse } from "../../../../../../types/api/api.types";
import { COMPANY_ENDPOINTS } from "../../../../../../utils/api/endpoints/companyEndpoints";

const PREFIX = '[updateNAFQuery]';

export const UPDATE_NAF_QUERY_KEY = 'UPDATE_NAF';

export const updateNAFQuery = async (fieldsOfActivity: string[]) => {
  console.log(PREFIX, `Updating NAF codes to company...`);

  const response = await COMPANY_ENDPOINTS.updateNAF(fieldsOfActivity);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Updated NAF codes to company.`);
  return json as BaseResponse;
};